import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import SweetAlert from "sweetalert2-react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import fire from "../config/Fire";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class EditarEvento extends React.Component {
  constructor(props) {
    super(props);
    this.titulo = props.titulo;
    this.detalle = props.detalle;
    this.link = props.link;
    this.nombreimg = props.nombreimg;
    this.precio = props.precio;
    this.direccion = props.direccion;
    this.fecha = props.fecha;
    this.hashtag = props.hashtag;
    this.handleUploadAR = this.handleUploadAR.bind(this);
    this.cambiosInputs = this.cambiosInputs.bind(this);
  }
  //Permite obtener la información del evento
  componentDidMount() {
    this.setState({
      titulo: this.titulo,
      detalle: this.detalle,
      link: this.link,
      nombreimg: this.nombreimg,
      precio: this.precio,
      direccion: this.direccion,
      fecha: this.fecha,
      hashtag: this.hashtag,
      imagen: null
    });
  }
  state = {
    open: false,
    value: null,
    disabled: true,
    link: "",
    contenido: "",
    titulo: "",
    imagen: null,
    uploadValue: 0,
    direccion: null,
    titulo1: ""
  };
  //Permite abrir el dialogo
  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };
  //Permite cerrar el dialogo
  handleClose = () => {
    this.setState({
      open: false,
      value: null,
      disabled: true,
      link: "",
      imagen: null,
      uploadValue: 0,
      direccion: null
    });
    this.setState({
      show: true,
      estado: "error",
      texto: "El evento no ha sido editado",
      titulo1: "Error"
    });
  };
  //Permite saber si es imágen o video la que tendrá el evento
  handleChange = event => {
    this.setState({ value: event.target.value });
    if (event.target.value === "imagen") {
      this.setState({ disabled: false });
    } else {
      this.setState({ disabled: true });
    }
  };
  //Guarda lo que escribe el usuario en los inputs
  cambiosInputs(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Crea el evento
  subirEvento = () => {
    if (this.state.value === "imagen") {
      if (this.state.uploadValue === 100) {
        fire
          .database()
          .ref()
          .child("Eventos")
          .orderByChild("titulo")
          .equalTo(this.titulo)
          .on("child_added", snapshot => {
            fire
              .database()
              .ref()
              .child("Eventos")
              .child(snapshot.key)
              .update({
                titulo: this.state.titulo,
                detalle: this.state.detalle,
                link: this.state.link,
                nombreimg: this.state.imagen.name,
                precio: this.state.precio,
                direccion: this.state.direccion,
                fecha: this.state.fecha,
                hashtag: this.state.hashtag
              });
            window.location.reload();
          });
      } else {
        this.setTimeout();
      }
    }
  };
  //Muestra el dialogo si se editó satisfactoriamente
  satisfactorio = () => {
    this.setState({
      open: false,
      value: null,
      disabled: true,
      link: "",
      imagen: null,
      uploadValue: 0,
      direccion: null
    });
    this.setState({
      show: true,
      estado: "success",
      texto: "El evento ha sido editado",
      titulo1: "¡Enhorabuena!"
    });
  };
  setTimeout = () => {
    setTimeout(this.subirEvento, 2000);
  };
  //Para saber que tipo de evento es
  handleNew = () => {
    if (
      this.state.titulo !== "" &&
      this.state.detalle !== "" &&
      this.state.precio !== "" &&
      this.state.fecha !== "" &&
      this.state.hashtag !== ""
    ) {
      if (this.state.value !== null && this.state.value !== "no") {
        if (this.state.value === "imagen") {
          if (this.state.imagen !== null) {
            this.subirImagen();
            this.subirEvento();
          } else alert("Debes ingresar la imagen del evento");
        }
      } else {
        this.actualizarTextos();
      }
    } else alert("Debes ingresar toda la información del evento");
  };
  actualizarTextos() {
    fire
      .database()
      .ref()
      .child("Eventos")
      .orderByChild("titulo")
      .equalTo(this.titulo)
      .on("child_added", snapshot => {
        fire
          .database()
          .ref()
          .child("Eventos")
          .child(snapshot.key)
          .update({
            titulo: this.state.titulo,
            detalle: this.state.detalle,
            link: this.state.link,
            nombreimg: this.state.nombreimg,
            precio: this.state.precio,
            direccion: this.state.direccion,
            fecha: this.state.fecha,
            hashtag: this.state.hashtag
          });
        window.location.reload();
      });
  }

  //Sube la imagen a firebase
  subirImagen() {
    this.setState({ show: false });

    this.setState({ nombreimg: null });

    fire.auth().onAuthStateChanged(user => {
      fire
        .database()
        .ref()
        .child("Eventos")
        .orderByChild("titulo")
        .equalTo(this.titulo)
        .on("child_added", snapshot => {
          this.setState({ nombreimg: snapshot.val().nombreimg });
        });
      if (user) {
        const storageRefImg = fire
          .storage()
          .ref(`/Eventos/${this.titulo}/${this.nombreimg}`);
        storageRefImg
          .delete()
          .then(function() {})
          .catch(function(error) {});
        const storageRef = fire
          .storage()
          .ref(`/Eventos/${this.state.titulo}/${this.state.imagen.name}`);
        const task = storageRef.put(this.state.imagen);
        task.on(
          "state_changed",
          snapshot => {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({
              uploadValue: percentage
            });
          },
          error => {},
          () => {
            storageRef.getDownloadURL().then(url => {
              this.setState({
                direccion: url
              });
            });
          }
        );
      }
    });
  }

  //Guarda información de la imagen
  handleUploadAR(event) {
    const file = event.target.files[0];
    this.setState({ imagen: file });
  }
  //Renderiza la interfaz del diálogo
  render() {
    return (
      <div>
        <div>
          <Button color="primary" onClick={this.handleClickOpen}>
            EDITAR
          </Button>
          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Editar evento: " + this.titulo}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="outlined-full-width"
                label="Descripción"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="detalle"
                onChange={this.cambiosInputs}
                value={this.state.detalle}
              />
              <TextField
                id="date"
                label="Fecha del evento"
                type="date"
                defaultValue=""
                name="fecha"
                onChange={this.cambiosInputs}
                value={this.state.fecha}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-full-width"
                label="Precio"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="precio"
                onChange={this.cambiosInputs}
                value={this.state.precio}
              />
              <TextField
                id="outlined-full-width"
                label="Link a boleto"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="link"
                onChange={this.cambiosInputs}
                value={this.state.link}
              />
              <TextField
                id="outlined-full-width"
                label="Ciudad"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="hashtag"
                onChange={this.cambiosInputs}
                value={this.state.hashtag}
              />

              <FormControl component="fieldset">
                <FormLabel component="legend">Editar contenido</FormLabel>
                <RadioGroup
                  aria-label="Gender"
                  name="gender1"
                  value={this.state.value}
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    value={"imagen"}
                    control={<Radio />}
                    label={"Imagen"}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Sin cambios"
                  />
                </RadioGroup>
              </FormControl>
              <div>
                <br />
                <input
                  accept="image/*"
                  type="file"
                  disableUnderline={true}
                  disabled={this.state.disabled}
                  name="Imagen"
                  onChange={this.handleUploadAR}
                />
                <br />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleNew} color="primary">
                Editar evento
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <SweetAlert
            show={this.state.show}
            title={this.state.titulo1}
            type={this.state.estado}
            text={this.state.texto}
            onConfirm={() => this.setState({ show: false })}
          />
        </div>
      </div>
    );
  }
}

export default EditarEvento;
